import { Category } from '../../core/models/category.model';
import { ImageData } from '../../core/models/imagedata.model';
import { FileData } from '../../core/models/filedata.model';
export class Documentos {


  id: number;
  contentTypeId: number;
  contentTypeName: string;
  isPublic: boolean;
  title: string;
  shortText: string;
  mainText: string;
  introText: string;
  modeifiedOn: string;
  createdOn: string;
  images: ImageData[];
  files: FileData[];
  createdBy: string;
}





// WEBPACK FOOTER //
// ./src/app/documents/shared/document.model.ts